import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { _getSupportedLanguages, _getSiteLanguages } from '../shared/httpservice/apis/multiLanguages';
const createInitialState = () => ({
    loading: false,
    response: null,
    hasError: false,
    error: {},
});
// -----------------------------
// Initial State
// -----------------------------
const initialState = {
    getSupportedLanguages: createInitialState(),
    getSiteLanguages: createInitialState(),
};
// -----------------------------
// Async Thunks
// -----------------------------
export const getSupportedLanguagesAction = createAsyncThunk('multilanguage/getSupportedLanguages', async (_, { rejectWithValue }) => {
    try {
        const response = await _getSupportedLanguages();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const getSiteLanguagesAction = createAsyncThunk('multilanguage/getSiteLanguages', async (siteId, { rejectWithValue }) => {
    try {
        const response = await _getSiteLanguages(siteId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
// -----------------------------
// Slice
// -----------------------------
const multilanguageSlice = createSlice({
    name: 'multilanguage',
    initialState,
    reducers: {
        resetMultilanguageSlice: () => initialState,
    },
    extraReducers: (builder) => {
        // Supported Languages
        builder
            .addCase(getSupportedLanguagesAction.pending, (state) => {
            state.getSupportedLanguages.loading = true;
            state.getSupportedLanguages.response = null;
            state.getSupportedLanguages.hasError = false;
            state.getSupportedLanguages.error = {};
        })
            .addCase(getSupportedLanguagesAction.fulfilled, (state, action) => {
            state.getSupportedLanguages.loading = false;
            state.getSupportedLanguages.response = action.payload;
            state.getSupportedLanguages.hasError = false;
        })
            .addCase(getSupportedLanguagesAction.rejected, (state, action) => {
            state.getSupportedLanguages.loading = false;
            state.getSupportedLanguages.hasError = true;
            state.getSupportedLanguages.error = action.payload;
        });
        // Site Languages
        builder
            .addCase(getSiteLanguagesAction.pending, (state) => {
            state.getSiteLanguages.loading = true;
            state.getSiteLanguages.response = null;
            state.getSiteLanguages.hasError = false;
            state.getSiteLanguages.error = {};
        })
            .addCase(getSiteLanguagesAction.fulfilled, (state, action) => {
            state.getSiteLanguages.loading = false;
            state.getSiteLanguages.response = action.payload;
            state.getSiteLanguages.hasError = false;
        })
            .addCase(getSiteLanguagesAction.rejected, (state, action) => {
            state.getSiteLanguages.loading = false;
            state.getSiteLanguages.hasError = true;
            state.getSiteLanguages.error = action.payload;
        });
    },
});
export const { resetMultilanguageSlice } = multilanguageSlice.actions;
export default multilanguageSlice.reducer;
